import React from "react";
import { connect } from 'react-redux';
import { Card, CardHeader, CardBody, Table, Badge } from "reactstrap";
import reduxHelper from "./../../../helper/index.js";
import { getAvatarUrl } from "./../../../helper/avatarHelper.js";

class BadgeLeaderboard extends React.Component {

  constructor(props) {
    super(props);
    this.state = { loading: true };
    this.helper = new reduxHelper(this.props);
  }

  async componentDidMount() {
    if (this.props.classroomId) {
      await this.helper.badge().getLeaderboard(this.props.classroomId, 10);
    }
    this.setState({ loading: false });
  }

  getRankIcon(index) {
    if (index === 0) return <i className="fas fa-trophy" style={{ color: '#FFD700', fontSize: '1.2rem' }} />;
    if (index === 1) return <i className="fas fa-medal" style={{ color: '#C0C0C0', fontSize: '1.1rem' }} />;
    if (index === 2) return <i className="fas fa-medal" style={{ color: '#CD7F32', fontSize: '1rem' }} />;
    return <span className="text-muted font-weight-bold">{index + 1}º</span>;
  }

  render() {

    var leaderboard = this.props.badge.leaderboard || [];
    var translate = this.props.translate || {};

    return (
      <Card className="shadow">
        <CardHeader>
          <h5 className="mb-0">
            <i className="fas fa-trophy mr-2" />
            {translate['ranking_badges'] || 'Ranking de Badges'}
          </h5>
        </CardHeader>
        <CardBody className="p-0">
          {this.state.loading ? (
            <div className="text-center py-4">
              <i className="fas fa-spinner fa-spin fa-2x text-muted" />
            </div>
          ) : leaderboard.length === 0 ? (
            <div className="text-center py-4">
              <p className="text-muted mb-0">{translate['sem_ranking'] || 'Sem dados de ranking ainda'}</p>
            </div>
          ) : (
            <Table responsive className="align-items-center mb-0" hover>
              <thead className="thead-light">
                <tr>
                  <th style={{ width: '60px' }}>#</th>
                  <th>{translate['aluno'] || 'Aluno'}</th>
                  <th className="text-center" style={{ width: '100px' }}>{translate['badges'] || 'Badges'}</th>
                </tr>
              </thead>
              <tbody>
                {leaderboard.map((item, index) => (
                  <tr key={item.user} style={index < 3 ? { backgroundColor: index === 0 ? '#FFF8E1' : 'transparent' } : {}}>
                    <td className="text-center">{this.getRankIcon(index)}</td>
                    <td>
                      <div className="d-flex align-items-center">
                        <img
                          src={getAvatarUrl({ id: item.user, photo: item.photo }, 'personas', { size: 36 })}
                          alt="avatar"
                          style={{
                            width: '36px',
                            height: '36px',
                            borderRadius: '50%',
                            marginRight: '10px',
                            border: index === 0 ? '2px solid #FFD700' : '1px solid #eee',
                            backgroundColor: '#f8f9fa'
                          }}
                        />
                        <div>
                          <span className="font-weight-bold">{item.name}</span>
                          {item.lastName ? <span className="text-muted ml-1">{item.lastName}</span> : null}
                        </div>
                      </div>
                    </td>
                    <td className="text-center">
                      <Badge color="primary" pill style={{ fontSize: '0.9rem' }}>
                        {item.total}
                      </Badge>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </CardBody>
      </Card>
    );

  }

}

export default connect(state => ({
  badge: state.badge,
  translate: state.translate
}))(BadgeLeaderboard);
